//状态
//基础文字按钮
//组件默认设置提示文字

export default {
  service_error: 'Server deserted',
  '删除': 'Delete',
  '暂无数据': 'no data',
  '是': 'YES',
  '否': 'NO',
  "下一步": "Next",
  "上一步": "Previous",
  "提交订单": "Submit Order",
  "展位号": "Booth",
  "申请时间": "Apply Time",
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/base/base.js